<template>
  <div id="header-app" class="header-app in-module">
    <header id="site-header">
      <div class="max">
        <figure class="logo">
          <a href="/">
            <img src="/images/common/logo.webp" alt="รับผลิตริสแบนด์ด้วยดีไซน์ของคุณ" />
          </a>
        </figure>
        <h1>รับผลิตริสแบนด์<br>ด้วยดีไซน์ของคุณ</h1>
        <div class="meta">
          <div class="meta__tel">
            <a href="tel:0615422364"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M757.23-160q-101.15 0-207.38-50.65-106.23-50.66-197.77-142.2-90.77-91.53-141.43-197.38Q160-656.08 160-757.23q0-18 12-30.39Q184-800 202-800h98.92q16.31 0 28.46 10.27 12.16 10.27 16.47 26.35L365.69-668q2.77 16.77-1 29.31t-13.31 20.54l-87.76 81.84q24.61 44.69 54.42 83.04 29.81 38.35 63.58 72.65 34.84 34.85 75 64.81 40.15 29.96 88.15 56.58l85.54-87.08q9.77-10.54 21.96-13.88 12.19-3.35 26.96-1.35l84.15 17.23q16.31 4 26.47 16.43Q800-315.46 800-299.38V-202q0 18-12.38 30-12.39 12-30.39 12Z"/></svg>061-542-2364</a>
            <a href="tel:0972387293"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M757.23-160q-101.15 0-207.38-50.65-106.23-50.66-197.77-142.2-90.77-91.53-141.43-197.38Q160-656.08 160-757.23q0-18 12-30.39Q184-800 202-800h98.92q16.31 0 28.46 10.27 12.16 10.27 16.47 26.35L365.69-668q2.77 16.77-1 29.31t-13.31 20.54l-87.76 81.84q24.61 44.69 54.42 83.04 29.81 38.35 63.58 72.65 34.84 34.85 75 64.81 40.15 29.96 88.15 56.58l85.54-87.08q9.77-10.54 21.96-13.88 12.19-3.35 26.96-1.35l84.15 17.23q16.31 4 26.47 16.43Q800-315.46 800-299.38V-202q0 18-12.38 30-12.39 12-30.39 12Z"/></svg>097-238-7293</a>
          </div>
          <ul class="meta__qr">
            <li>
              <figure>
                <a href="https://line.me/ti/p/%40bwo4637d" target="_blank" rel="nofollow">
                  <img src="/images/common/qr_bnr_01.webp" alt="LINE QR Code">
                </a>
              </figure>
            </li>
            <li>
              <figure>
                <a href="https://line.me/ti/p/AuNgHZlbqU" target="_blank" rel="nofollow">
                  <img src="/images/common/qr_bnr_02.webp" alt="LINE QR Code">
                </a>
              </figure>
            </li>
            <li class="toJP">
              <a href="https://www.rocket-wristband.com/" target="_blank" rel="nofollow">
                <figure><img src="/images/common/hinomaru.gif" alt="日本語サイト"></figure>
                <span>日本語</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <navi />
  </div>
</template>

<style lang="scss" scoped>
.header-app{
  width: 100%;
  position: fixed;
  background: module.$white;
  box-shadow: 0 0 3.2rem rgba(module.$normal,.12);
  z-index: 1000;
  transition: transform 300ms module.$ease;
  &.active{
    transform: translateY(calc(-1 * var(--head)));
    transition: transform 400ms module.$ease;
    @media screen and (max-width: module.$phone){
      transform: translateY(0);
    }
  }
  header{
    border-bottom: module.$border 1px solid;
    padding: 0 module.side();
    @media screen and (max-width: module.$phone){
      padding: .8rem module.side();
    }
    .max{
      display: grid;
      grid-template-columns: auto auto 1fr;
      gap: 2.4rem;
      padding: 0 1.6rem;
      @media screen and (max-width: module.$tab){
        grid-template-columns: auto 1fr;
        gap: 2rem;
        padding: 0;
      }
      @media screen and (max-width: module.$phone){
        gap: .4rem;
      }
      > *{
        align-self: center;
      }
    }
    .logo{
      width: 14rem;
      justify-self: flex-start;
      a{
        @include module.flex();
        align-items: center;
      }
      @media screen and (max-width: module.$tab){
        width: 12.8rem;
      }
      @media screen and (max-width: module.$phone){
        width: 8rem;
      }
      img{
        width: 100%;
      }
    }
    h1{
      font-size: .88rem;
      font-weight: 400;
      line-height: 1.5;
      @media screen and (max-width: module.$tab){
        display: none;
      }
    }
    .meta{
      @include module.flex();
      justify-content: flex-end;
      align-items: center;
      &__tel{
        display: grid;
        gap: .24rem;
        @media screen and (max-width: module.$phone){
          padding: 0 3.6rem 0 0;
        }
        a{
          font-size: 1.24rem;
          line-height: 1;
          @include module.flex();
          align-items: center;
          justify-content: flex-start;
          white-space: nowrap;
          @media screen and (max-width: module.$tab){
            font-size: 1.2rem;
          }
          @media screen and (max-width: module.$phone){
            font-size: .8rem;
          }
          &:nth-of-type(even){
            svg{
              background: module.$sub;
            }
          }
          svg{
            width: 1.72rem;
            height: 1.72rem;
            padding: .32rem;
            display: block;
            margin: 0 .56rem 0 0;
            fill: module.$white;
            background: module.$main;
            border-radius: 50%;
            @media screen and (max-width: module.$tab){
              width: 1.48rem;
              height: 1.48rem;
            }
            @media screen and (max-width: module.$phone){
              width: 1rem;
              height: 1rem;
              padding: .12rem;
            }
          }
        }
      }
      &__qr{
        @include module.flex();
        justify-content: flex-end;
        align-items: center;
        margin: 0 0 0 2rem;
        padding: .24rem 0 .24rem 1.2rem;
        border-left: module.$border 1px solid;
        position: relative;
        &:before{
          content: '';
          width: 1px;
          height: 100%;
          background: module.$border;
          position: absolute;
          top: 0;
          right: 5.2rem;
        }
        @media screen and (max-width: module.$phone){
          display: none;
        }
        li{
          width: 4rem;
          margin: 0 0 0 .4rem;
          @media screen and (max-width: module.$tab){
            width: 3.6rem;
          }
          &:first-child{
            margin: 0;
          }
          img{
            width: 100%;
          }
          &.toJP{
            margin: 0 0 0 2.4rem;
            transform: translateY(.24rem);
            @media screen and (max-width: module.$phone){
              display: none;
            }
            figure{
              width: 3.2rem;
              img{
                width: 100%;
              }
            }
            span{
              width: 3.2rem;
              margin: .4rem 0 0;
              display: block;
              text-align: center;
              font-size: .8rem;
              opacity: .8;
            }
          }
        }
      }
    }
  }  
}
</style>

<script>
import navi from './navi.vue'
export default {
  components: {
    navi: navi,
  }
}
</script>
